import React from "react";
import { WorkflowSettings } from "../manage-workflows/workflow-settings";

export const AgencySettingsWorkflow: React.FC<unknown> = () => {
    return <WorkflowSettings scope="tenant" />;
};
